export const menuItems = [
  { key: 'dashboard', url: '/', icon: 'home', title: 'title.main' },
  { key: 'news', url: '/news', icon: 'file-text', title: 'title.news' },
  { key: 'partners', url: '/partners', icon: 'team', title: 'title.partners' },
  { key: 'journal', url: '/journal', icon: 'book', title: 'title.journal' },
  { key: 'finance', url: '/finance', icon: 'wallet', title: 'title.finance' },
  { key: 'referral-links', url: '/referral-links', icon: 'link', title: 'title.referral-links' },
  { key: 'photobank', url: '/photobank', icon: '', title: 'title.photobank', hidden: true },
  { key: 'files', url: '/files', icon: 'file', title: 'title.files', hidden: true },
  { key: 'videobank', url: '/videobank', icon: '', title: 'title.videobank', hidden: true },
  { key: 'sales-report', url: '/sales-report', icon: 'fund', title: 'title.sales-report' },
  { key: 'diagnostician-materials', url: '/diagnostician-materials', icon: 'diagnostician-materials', title: 'title.diagnostician-materials', hidden: true },
]
